import React, { FC, ComponentProps as CP } from 'react'
import classNames from 'classnames'
import Transition from 'react-transition-group/Transition'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

export type Props = CP<typeof Transition> & {
  component?: React.ComponentType<{ className?: string }>
  componentProps?: Object
}

const duration = 300

const styles = createStyles({
  root: {
    transition: `all ${duration}ms ease-in-out`,
  },
  entering: {
    opacity: 0,
    transform: 'scale(1.5)',
  },
  entered: {
    opacity: 1,
    transform: 'scale(1)',
  },
  exiting: {
    opacity: 1,
    transform: 'scale(1)',
  },
  exited: {
    opacity: 0,
    transform: 'scale(1.5)',
  },
  unmounted: {}
})

type InjectedProps = Props & WithStyles<typeof styles>

const Shrink: FC<InjectedProps> = ({
  classes,
  children,
  className,
  component,
  componentProps,
  ...props
}) => {
  const Component = component ? component : 'div'
  const ComponentProps = componentProps ? componentProps : {}

  return (
    <Transition {...props}>
      {(state) => (
        <Component className={classNames(className, classes.root, classes[state])} {...ComponentProps}>
          {children}
        </Component>
      )}
    </Transition>
  )
}

export default withStyles(styles)(Shrink)
